import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '../../main/components/Header';
import Events from './Events';
import FooterCards from './FooterCards';

const EventsLayout: React.FC = () => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <div className={classNames(['grid-container', 'padding-bottom-4', 'ofertas-eventos'])}>
                <div className={classNames(['grid-x', 'grid-margin-x'])}>
                    <Header title={t('events:header')} />
                    <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                        <Events />
                    </div>
                    <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                        <hr />
                    </div>
                    <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                        <p className={'text-bold'}>{t('events:subHeader')}</p>
                        <FooterCards />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default EventsLayout;
